const routes = [
    {
        path: "/census/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'system.censusreports_access'
        }
    }
];

export default routes;
